function formatDate(dateData) {
    if (dateData === null) return;

    return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(new Date(dateData))
}

function formatDatetime(dateData) {
    if (dateData === null) return;

    const d = new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(dateData));
    const t = new Intl.DateTimeFormat('fr-FR', { hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(dateData)).replace(':', 'h');

    return `${d} à ${t}`;
}

function formatMonth(month) {
    if (!month) {
        return ""
    }

    switch (month.toString()) {
        case "01":
          return 'Janvier'
        case '02':
            return 'Février'
        case '03':
            return 'Mars'
        case '04':
            return 'Avril'
        case '05':
            return 'Mai'
        case '06':
            return 'Juin'
        case '07':
            return 'Juillet'
        case '08':
            return 'Aout'
        case '09':
            return 'Septembre'
        case '10':
            return 'Octobre'
        case '11':
            return 'Novembre'
        case '12':
            return 'Décembre'
        default:
          return ""
      }
}

function formatMonthYear(dateData) {
    if (!dateData) return '';

    const date = new Date(dateData);
    const month = String(date.getMonth() + 1).padStart(2, '0');

    return `${formatMonth(month)} ${date.getFullYear()}`;
}

function formatGender(gender) {
    switch (gender) {
        case "Male":
          return 'M.'
        case 'Female':
            return 'Mme'
        default:
          return ""
      } 
}

export default {methods: {
    formatMonth, formatDate, formatDatetime, formatMonthYear, formatGender
}}